import {Icon} from '@blueprintjs/core'
import {currencyToSymbolMap, Tooltip2} from '@api'

import {Tooltip} from '@material-ui/core'
import {useGroupByGroupStore} from '@modules/catalog'
import {GroupTitleConfig, isNumericAttribute} from '@stores'
import {React, observer} from '@api'
import {_} from '../../../../../../../../../shared/components/3rd-party'
import * as css from './GroupSubtitleField.css'

export const GroupSubtitles = observer(function GroupSubtitles() {
  const {grouping: {subtitleFields}} = useGroupByGroupStore(),
    subtitleComponents = (subtitleFields ?? []).map((f, i) => <GroupSubtitleField key={f.field ?? i} field={f}/>).filter(_.identity)

  return (
    _.isEmpty(subtitleComponents) || !subtitleComponents?.length ? null
    : <div className={css.subtitles} data-type='GroupSubtitles'>
      {subtitleComponents}
    </div>)
})

export const GroupSubtitleField = observer<{ field: GroupTitleConfig }>(function GroupSubtitleField({field}) {
  const {strings, catalog, grouping: {orderBy, toggleSortField}, props: {info, info: {keys}}, valueForSubtitleField, groupBy: {viewStore}} = useGroupByGroupStore(),
    orderByField = field.field ? orderBy.find(f => f.field == field.field) : null

  const catalogField = catalog._fieldByName[field.field]

  let value = valueForSubtitleField(field),
    valueLabel = value?.label

  if (!field.valueFor && catalogField?.group?.titleFor) {
    valueLabel = catalogField.group.titleFor(info)
  }

  if ((field.valueFor || catalogField?.group?.titleFor) && (valueLabel === null || valueLabel === undefined)) return null

  const def = catalogField?.def,
    currencyIcon = currencyToSymbolMap[_.toUpper(def?.currency)],
    precision = def?.precision ?? (def?.type == 'Int' ? 0 : 2),
    isNumericField = isNumericAttribute(def),
    precisionFormatter = isNumericField && new Intl.NumberFormat(undefined, {minimumFractionDigits: precision, maximumFractionDigits: precision}),
    innerLabel = valueLabel === undefined || valueLabel === null
                 ? (viewStore?.mgr?.loading ? strings.emptyLabel : strings.unassigned)
                 : valueLabel === '' ? strings.noValue
                                : isNumericField
                                  ? precisionFormatter.format(value.item)
                                  : catalog.attrValueLabelFor({v: valueLabel, def: catalogField?.def}),
    subtitleLabel = !innerLabel ? '' : valueLabel === undefined || valueLabel === null ? innerLabel : `${field.prefix ?? ''}${currencyIcon ?? ''}${innerLabel}${def?.suffix ?? ''}`

  return (
    <div className={css.subtitleContainer}
         data-field={field.field}
         data-type='subtitle'
         onClick={toggleSortField(field.field)}>
      <Tooltip2 placement='bottom' content={catalog.labelForFieldName_currentCatalog(field.field)}>
        <div className={css.subtitle}>{subtitleLabel}</div>
      </Tooltip2>
      {orderByField && <Icon icon={orderByField.order == 'asc' ? 'caret-up' : 'caret-down'} />}
      {/*<PrimaryIconButton className={css.deleteButton} icon={<Icon icon='small-cross'/>} onClick={removeSubtitleField(field.field)}/>*/}
    </div>)
})


// WEBPACK FOOTER //
// ./src/modules/catalog/internal/gridList/components/groupBy/GroupByCatalog/GroupByCatalog_Groups/GroupByCatalog_LoadMore/GroupSubtitleField.tsx